/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { hasElements } from "utils/arrays";
import ChatContext from "./ChatContext";
import Conversation from "./Conversation";

function Conversations({ onConversationSelected }) {
    const { conversations, selectedConversation, isSingleConversation } = useContext(ChatContext);
    const [filter, setFilter] = useState("");

    useEffect(() => {
        if (isSingleConversation) {
            onConversationSelected(conversations[0]);
        }
    }, [isSingleConversation]);

    const getConversations = () => {
        const parsedFilter = String(filter).trim().toLowerCase();
        if (parsedFilter) {
            return conversations.filter((x) => String(x.friendlyName).toLowerCase().includes(parsedFilter.toLowerCase()));
        }
        return conversations;
    };

    const onFilterChanged = (event) => setFilter(event.target?.value);
    
    return (
        <section className="conversations">
            <div className="search">
                <input type="text" value={filter} onChange={onFilterChanged} placeholder="Search..." />
            </div>
            <div className="items">
                {hasElements(conversations) &&
                    getConversations().map((conversation) => (
                        <Conversation
                            key={conversation.sid}
                            conversation={conversation}
                            onClick={() => onConversationSelected(conversation)}
                            isSelected={conversation.sid === selectedConversation?.sid}
                        />
                    ))}
            </div>
        </section>
    );
}

export default Conversations;
